import { render, staticRenderFns } from "./edit.schedules.page.vue?vue&type=template&id=10e3d7ed&"
import script from "./edit.schedules.page.vue?vue&type=script&lang=js&"
export * from "./edit.schedules.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports